<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top: 5%; height: 85%; overflow-y: hidden"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色名称">
          <a-input disabled placeholder="请输入角色名称" v-decorator="['roleName', validatorRules.roleName]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色类型">
          <j-dict-select-tag
            disabled
            :trigger-change="true"
            type="list"
            v-decorator="['roleType', validatorRules.roleType]"
            placeholder="请选择角色类型"
            dictCode="role_type"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划类型">
          <j-dict-select-tag
            disabled
            :trigger-change="true"
            type="list"
            v-decorator="['planType', validatorRules.planType]"
            dictCode="role_plan_type"
            @change="planTypeChange"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="showHasNoon" label="是否设置上下午">
          <a-radio-group
            disabled
            @change="hasNoonChange"
            v-decorator="['hasNoon', validatorRules.hasNoon]"
            :options="[
              { label: '是', value: '1', key: '是' },
              { label: '否', value: '0', key: '否' },
            ]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否临时任务">
          <a-radio-group
            v-decorator="['hasTemporaryTasks', validatorRules.hasTemporaryTasks]"
            :options="[
              { label: '是', value: '1', key: '是' },
              { label: '否', value: '0', key: '否' },
            ]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon && hasNoonValue"
          label="上午次数"
        >
          <a-input-number
            size="large"
            :min="1"
            :max="10"
            v-decorator="['morningPlanNum', validatorRules.morningPlanNum]"
            @change="noonValueChangeMorning"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showHasNoon && hasNoonValue"
          label="下午次数"
        >
          <a-input-number
            size="large"
            :min="1"
            :max="10"
            v-decorator="['afternoonPlanNum', validatorRules.afternoonPlanNum]"
            @change="noonValueChangeAfternoon"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划次数">
          <a-input-number size="large" :min="1" :max="20" v-decorator="['planNum', validatorRules.planNum]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="showHasNoon" label="指定生成周期">
          <a-checkbox-group
            name="workDays"
            v-decorator="['workDays', validatorRules.workDays]"
            :options="workDaysOptions"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { postAction } from '@/api/manage'
import moment from 'moment'
export default {
  name: 'RoleModal',
  data() {
    return {
      userConfigId: '',
      hasNoonValue: false,
      showHasNoon: false,
      title: '操作',
      visible: false,
      roleDisabled: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        roleName: {},
        roleCode: {},
        description: {},
        roleType: {
          initialValue: '',
        },
        planType: {
          initialValue: '',
        },
        hasNoon: {
          initialValue: '0',
        },
        hasTemporaryTasks: {
          initialValue: '0',
        },
        planNum: {
          initialValue: '',
        },
        morningPlanNum: {
          initialValue: '',
        },
        afternoonPlanNum: {
          initialValue: '',
        },
        workDays: {
          initialValue: [],
        },
      },
      workDaysOptions: [
        { label: '星期一', value: '2' },
        { label: '星期二', value: '3' },
        { label: '星期三', value: '4' },
        { label: '星期四', value: '5' },
        { label: '星期五', value: '6' },
        { label: '星期六', value: '7' },
        { label: '星期日', value: '1' },
      ],
    }
  },
  created() {},
  mounted() {},
  methods: {
    getUserConfig(parameter) {
      this.confirmLoading = true
      postAction('/inspection/user/config/edit', parameter)
        .then((res) => {
          if (res.code == 200) {
            if (res.result.workDays) {
              //数组去重
              const set = new Set(res.result.workDays.split(','))
              res.result.workDays = [...set]
              console.log(res.result)
            } else {
              res.result.workDays = ''
            }
            this.$nextTick(() => {
              this.form.setFieldsValue(
                pick(
                  res.result,
                  'morningPlanNum',
                  'afternoonPlanNum',
                  'planNum',
                  'hasTemporaryTasks',
                  'hasNoon',
                  'workDays'
                )
              )
            })
            if (res.result.id) {
              this.userConfigId = res.result.id
            } else {
              this.userConfigId = ''
            }
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.confirmLoading = false
        })
    },
    setUserConfig(parameter) {
      postAction('/inspection/user/config/save', parameter)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('配置成功')
            this.visible = false
            this.$emit('refreshTable')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    noonValueChangeMorning(newValue) {
      let values = this.form.getFieldsValue(['afternoonPlanNum'])
      this.addPlanNum(values.afternoonPlanNum, newValue)
    },
    noonValueChangeAfternoon(newValue) {
      let values = this.form.getFieldsValue(['morningPlanNum'])
      this.addPlanNum(values.morningPlanNum, newValue)
    },
    addPlanNum(Morning, Afternoon) {
      if (Morning === '' && Afternoon === '') {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            planNum: '',
          })
        })
        return
      }
      let adds = (Morning ? Morning : 0) + (Afternoon ? Afternoon : 0)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          planNum: adds,
        })
      })
    },
    planTypeChange(newVal) {
      if (newVal == 'day') {
        this.showHasNoon = true
      } else {
        this.showHasNoon = false
      }
    },
    hasNoonChange(e) {
      this.hasNoonValue = e.target.value == '1' ? true : false
      let values = this.form.getFieldsValue(['afternoonPlanNum', 'morningPlanNum'])
      console.log('hasNoonChange')
      console.log(values)
      this.addPlanNum(values.afternoonPlanNum, values.morningPlanNum)
    },
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.getUserConfig({
        roleId: record.roleId,
        userId: record.id,
        roleConfigId: record.roleConfigId,
      })
      this.$nextTick(() => {
        let data = pick(
          this.model,
          'planNum',
          'planType',
          'roleType',
          'roleName',
          'hasNoon',
          'morningPlanNum',
          'afternoonPlanNum',
          'hasTemporaryTasks'
        )
        this.form.setFieldsValue(data)
        let values = pick(this.model, 'planType', 'hasNoon', 'morningPlanNum', 'afternoonPlanNum')
        this.addPlanNum(values.afternoonPlanNum, values.morningPlanNum)
        this.planTypeChange(values.planType)
        this.hasNoonChange({ target: { value: values.hasNoon } })
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          let objTemp = pick(this.model, 'roleId', 'roleConfigId')
          objTemp.userId = this.model.id
          if (fieldsValue.workDays && fieldsValue.workDays.length > 0) {
            fieldsValue.workDays = fieldsValue.workDays.join(',')
          }
          let formData = Object.assign(objTemp, {
            morningPlanNum: fieldsValue.morningPlanNum,
            afternoonPlanNum: fieldsValue.afternoonPlanNum,
            planNum: fieldsValue.planNum,
            hasTemporaryTasks: fieldsValue.hasTemporaryTasks,
            hasNoon: fieldsValue.hasNoon,
            workDays: fieldsValue.workDays,
          })
          if (this.userConfigId) {
            formData.id = this.userConfigId
          } else {
            delete formData.id
          }
          this.setUserConfig(formData)
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateRoleCode(rule, value, callback) {
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback('角色编码不可输入汉字!')
      } else {
        var params = {
          tableName: 'sys_role',
          fieldName: 'role_code',
          fieldVal: value,
          dataId: this.model.id,
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      }
    },
  },
}
</script>

<style scoped></style>
